<template>
    <div class="modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Crear usuario</h5>
                    <button type="button" @click="closeModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="createUser">
                        <div class="form-group">
                            <label for="username-input">Usuario (login):</label>
                            <input type="text" v-model="formCreate.username" id="username-input" class="form-control" required>
                        </div>
                        <div class="form-group mt-2">
                            <label for="name-input">Nombre:</label>
                            <input type="text" v-model="formCreate.name" id="name-input" class="form-control" required>
                        </div>
                        <div class="form-group mt-2">
                            <label for="email-input">Correo electrónico:</label>
                            <input type="email" v-model="formCreate.email" id="email-input" class="form-control" required>
                        </div>
                        <div class="form-group mt-2">
                            <label for="password-input">Contraseña:</label>
                            <input type="password" v-model="formCreate.password" id="password-input" class="form-control" required>
                        </div>
                        <div class="form-group mt-2">
                            <label for="password_confirmation-input">Confirmar contraseña:</label>
                            <input type="password" v-model="formCreate.password_confirmation" id="password_confirmation-input" class="form-control" required>
                        </div>
                        <hr>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-danger me-2" @click="closeModal">Cancelar</button>
                            <button type="submit" class="btn btn-success">Crear</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
    name: 'CreateUserModal',
    data() {
        return {
            formCreate: {
                username: '',
                name: '',
                email: '',
                password: '',
                password_confirmation: ''
            }
        }
    },
    methods: {
        createUser() {
            axios.post('/api/user', this.formCreate)
                .then(response => {
                    showCustomSuccessSweetAlert('Usuario creado correctamente');
                    this.$emit('user-created');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        closeModal() {
            this.$emit('close-modal');
        },
    }
}
</script>